import React from 'react';
import Modal from '../common/Modal';
import { getAllowedTransitions, statusColors } from '../../utils/orderUtils';

const statusLabel = s => s.charAt(0).toUpperCase() + s.slice(1).replace('_', ' ');

export default function StatusUpdateModal({ state, setState, onSave }) {
  const allowed = state.order ? getAllowedTransitions(state.order.status) : [];
  const canSave = !!state.status && state.status !== state.order?.status;

  return (
    <Modal
      open={state.open}
      onClose={() => setState({ open: false })}
      title="Update Order Status"
      footer={<>
        <button className="btn btn-secondary" onClick={() => setState({ open: false })}>Cancel</button>
        <button className="btn btn-primary" onClick={onSave} disabled={!canSave}>Update</button>
      </>}
    >
      {state.order && (
        <div>
          <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
            Current status:
            <span className={`badge badge-${statusColors[state.order.status] || 'neutral'}`} style={{ textTransform: 'capitalize' }}>
              {statusLabel(state.order.status)}
            </span>
          </div>
          {allowed.length === 0 ? (
            <div style={{ padding: '12px 0', color: 'var(--text-muted)', fontSize: '0.85rem' }}>
              No further status transitions are available for this order.
            </div>
          ) : (
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="form-label">Change to</label>
              <select className="form-control form-select"
                value={state.status}
                onChange={e => setState(p => ({ ...p, status: e.target.value }))}>
                <option value="">— Select new status —</option>
                {allowed.map(s => (
                  <option key={s} value={s}>{statusLabel(s)}</option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}
    </Modal>
  );
}
